module.exports = __webpack_public_path__ + "img/phone-song-title.542d8d55.png";